import { render, staticRenderFns } from "./TemplateCategoryCard.vue?vue&type=template&id=a4b9a180&"
import script from "./TemplateCategoryCard.vue?vue&type=script&lang=js&"
export * from "./TemplateCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports